import styled from 'styled-components';

export const Section = styled.section`
  background: #161617;
  padding: 50px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 800;
  line-height: 32px;
  letter-spacing: 0;
  color: #ffffff;
  text-align: center;
`;

export const Cards = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Card = styled.button`
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 10px;
  overflow: hidden;
  text-align: left;
  cursor: pointer;
`;

export const Media = styled.div`
  width: 100%;
  height: 205px;
  background: #53595e;
  position: relative;
  overflow: hidden;
`;

export const EventImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export const PlaceholderLogo = styled.img`
  width: 129px;
  height: 24px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.25;
`;

export const Content = styled.div`
  width: 100%;
  background: #000000;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Meta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Status = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #d4ea2f;
`;

export const EventTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: #ffffff;
  min-height: 48px;
  white-space: pre-line;
`;

export const DateText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #9fa6aa;
`;

export const ViewAllButton = styled.button`
  width: 160px;
  height: 44px;
  border-radius: 4px;
  border: 0;
  background: #d4ea2f;
  color: #000000;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
`;

export const EmptyStateContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
`;

export const EmptyStateText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #9fa6aa;
  text-align: center;
`;

// Modal styles
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.1);
  max-width: 390px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
`;

export const ModalTitle = styled.div`
  flex: 1;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: #000000;
`;

export const CloseButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 14px;
    height: 2px;
    background: #0f0f0f;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 6px 16px 12px 16px;
`;

export const ModalImage = styled.div`
  width: 100%;
  height: 204px;
  border-radius: 8px;
  overflow: hidden;
  background: #53595e;
  position: relative;
`;

export const ModalEventImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export const ModalInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;
`;

export const ModalEventTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  color: #000000;
  white-space: pre-line;
`;

export const ModalDateText = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: #000000;
`;

export const ModalFooter = styled.div`
  padding: 12px 16px 16px 16px;
`;

export const ViewDetailsButton = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 4px;
  border: 0;
  background: #d4ea2f;
  color: #000000;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  text-align: center;
`;
